import { FaceMeshManager } from './faceMeshManager';
import { FaceSceneManager } from './faceSceneManager';

class FaceCameraManager {
  private static instance = new FaceCameraManager();

  private faceMeshManager = FaceMeshManager.getInstance();
  private faceSceneManager = FaceSceneManager.getInstance();
  private videoElement!: HTMLVideoElement;
  private lastVideoTime!: any;
  private screenshot = false;

  static getInstance(): FaceCameraManager {
    return FaceCameraManager.instance;
  }
  init(videoEle: HTMLVideoElement) {
    this.videoElement = videoEle;
  }

  startCamera() {
    if (this.lastVideoTime !== this.videoElement.currentTime) {
      this.lastVideoTime = this.videoElement.currentTime;
      this.updateFrame(this.videoElement);
    }
    requestAnimationFrame(this.startCamera.bind(this));
  }

  async updateFrame(videoEle: HTMLVideoElement) {
    await this.faceMeshManager.updateFrames(videoEle);
    // this.faceSceneManager.rendering();
    // if (!this.screenshot) {
    //   this.screenshot = true;
    //   setTimeout(() => {
    //     this.faceSceneManager.snapshot();
    //   }, 5000);
    // }
  }
}

export { FaceCameraManager };
